"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.TOKEN_CHECK_INTERVAL_SECONDS = exports.QS_USERNAME = exports.QS_STATE = exports.QS_REGISTRATION_TOKEN = exports.QS_REDIRECT_URI = exports.QS_CLIENT_TYPE = exports.QS_AUTH_CODE = exports.POLL_INTERVAL_ACTIVITY_SECONDS = exports.PKCE_STORAGE_KEY = exports.PATH_START_REGISTRATION = exports.PATH_NAVIGATION_WIDGET = exports.DIALOG_ELEMENT_ID = exports.DEFAULT_WARNING_MINUTES = exports.DEFAULT_INACTIVE_MINUTES = exports.AUTH_REFRESH_STORAGE_KEY = exports.AUTH_ID_STORAGE_KEY = exports.AUTH_ACCESS_STORAGE_KEY = void 0;const AUTH_ACCESS_STORAGE_KEY = 'accessToken';exports.AUTH_ACCESS_STORAGE_KEY = AUTH_ACCESS_STORAGE_KEY;
const AUTH_ID_STORAGE_KEY = 'idToken';exports.AUTH_ID_STORAGE_KEY = AUTH_ID_STORAGE_KEY;
const AUTH_REFRESH_STORAGE_KEY = 'refreshToken';exports.AUTH_REFRESH_STORAGE_KEY = AUTH_REFRESH_STORAGE_KEY;
const PKCE_STORAGE_KEY = "pkceKey";exports.PKCE_STORAGE_KEY = PKCE_STORAGE_KEY;

const QS_CLIENT_TYPE = "clientType";exports.QS_CLIENT_TYPE = QS_CLIENT_TYPE;
const QS_REDIRECT_URI = "redirectUri";exports.QS_REDIRECT_URI = QS_REDIRECT_URI;
const QS_AUTH_CODE = 'code';exports.QS_AUTH_CODE = QS_AUTH_CODE;
const QS_STATE = "state";exports.QS_STATE = QS_STATE;
const QS_REGISTRATION_TOKEN = "token";exports.QS_REGISTRATION_TOKEN = QS_REGISTRATION_TOKEN;
const QS_USERNAME = "username";exports.QS_USERNAME = QS_USERNAME;

const DIALOG_ELEMENT_ID = "auth-dialog";exports.DIALOG_ELEMENT_ID = DIALOG_ELEMENT_ID;


const PATH_START_REGISTRATION = "registration";exports.PATH_START_REGISTRATION = PATH_START_REGISTRATION;
const PATH_NAVIGATION_WIDGET = 'navigation/';


/**
 * Number of minutes before we consider user inactive
 * @type {number}
 */exports.PATH_NAVIGATION_WIDGET = PATH_NAVIGATION_WIDGET;
const DEFAULT_INACTIVE_MINUTES = 15;

/**
 * Number of seconds before inactivity
 * @type {number}
 */exports.DEFAULT_INACTIVE_MINUTES = DEFAULT_INACTIVE_MINUTES;
const DEFAULT_WARNING_MINUTES = 1;

/**
 * How often the timer runs the interval function in seconds
 * @type {number}
 */exports.DEFAULT_WARNING_MINUTES = DEFAULT_WARNING_MINUTES;
const POLL_INTERVAL_ACTIVITY_SECONDS = 1;exports.POLL_INTERVAL_ACTIVITY_SECONDS = POLL_INTERVAL_ACTIVITY_SECONDS;

const TOKEN_CHECK_INTERVAL_SECONDS = 60;exports.TOKEN_CHECK_INTERVAL_SECONDS = TOKEN_CHECK_INTERVAL_SECONDS;